module.exports = __webpack_public_path__ + "img/118.ff8d1e26.jpg";